// extracted by mini-css-extract-plugin
export default {"addToCartControl":"u2-z","giftCard":"v2-z","btnContainer":"w2-z","cartButton":"x2-z","disabled":"y2-z"};